import Config from '@skin_config';

const checkRouteConfig = (ticketsCount) => ({
  tickets: () => ticketsCount > 1 && Config.main.ticketAvailableViewMode.includes('card') && Config.enableMultipleTickets,
});

export default checkRouteConfig;
